import { hardRedirectTo } from '../../../utils';
import Button from '../../generic/Button';
import type { AuthContextState } from '../context/AuthContext';

type SamlLoginButtonProps = Pick<AuthContextState, 'samlURL'>;

const SamlLoginButton = ({ samlURL }: SamlLoginButtonProps) => (
  <div className="margin-bottom-sm">
    <Button
      type="secondary"
      size="large"
      onClick={() => samlURL && hardRedirectTo(samlURL)}
      isFullWidth
    >
      Sign In with SAML
    </Button>
  </div>
);

export default SamlLoginButton;
